import api from './api';

export const getSuppliers = (params) => api.get('/suppliers', { params });
export const getSupplier = (id) => api.get(`/suppliers/${id}`);
export const createSupplier = (data) => api.post('/suppliers', data);
export const updateSupplier = (id, data) => api.put(`/suppliers/${id}`, data);
export const deleteSupplier = (id) => api.delete(`/suppliers/${id}`);
export const getSupplierTransactions = (id, params) => api.get(`/suppliers/${id}/transactions`, { params });
export const recordSupplierPurchase = (id, data) => api.post(`/suppliers/${id}/purchase`, data);
export const recordSupplierPayment = (id, data) => api.post(`/suppliers/${id}/payment`, data);
